import { ILeagues } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidLeagues } from './typeguards';
import { CreateCompetitionTeamInputSchema } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { LeaguesQuery } from '../types';
import { intcmpMap } from '../../../utils/intcmp';

export default (obj: LeaguesQuery): ILeagues=> {
  if (isValidLeagues(obj)) {
    CreateCompetitionTeamInputSchema().parse(obj.data.getCompetitionTeam, {reportInput: true});

    return {
      leagues: obj?.data?.getCompetitionTeam?.competitions || [],
      customTrackingData: intcmpMap.leagues,
    } as ILeagues;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LeaguesQuery object',
      data: obj
    });
  }
};
